exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-back-painel{background-color:rgba(0,0,0,0);border:none;margin-top:1.7rem}.painel-watch .b-tabs{margin:0}.painel-watch .card.card-monitor-component{max-width:288px}.painel-watch .tabs li{width:33.3333333333%}.painel-watch .tabs li a{font-weight:bold}.painel-watch .tabs li.is-active a{border-bottom-color:#36f;color:#36f}", ""]);

// exports
